window.ya_commerce = new function () {


    var testContainer = function () {
        return !!window['dataLayer'];
    };

    var findRoute = function () {
        var $detail = $('.js-ya-commerce-detail-show');
        if ($detail.length > 0) {
            this.route = 'detail';
            this.products = [{
                "id": $detail.data('id'),
                "name" : $detail.data('name'),
                "price": $detail.data('price'),
                "category": $detail.data('category')
            }];
        }

        var $bought = $('.js-ya-commerce-purchase');
        if($bought.length > 0) {
            this.route = 'purchase';
            this.products = window.products;
            this.actionField = {'id':window.purchaseActionID};
        }
    };
    findRoute.bind(this);

    var setPushes = function (route,products,actionField) {
        if (route) {
            products.forEach(function(el,i){
                products[i].name = el.name.replace(/[«»]/g,'"');
            });
            var obj = {"ecommerce": {}};
            obj.ecommerce[route] = {
                "products": products
            };
            if(actionField){
                obj.ecommerce[route]['actionField'] = actionField;
            }

            window['dataLayer'].push(obj);
        }
    };
    setPushes.bind(this);

    var setTriggers = function () {
        var $cart = $('.js-ya-commerce-add-cart');
        if ($cart.length>0) {
            $('body').on('click','.js-ya-commerce-add-cart',function () {
                this.products[0]['quantity'] = $('.js-count').html();
                setPushes('add', this.products);
            }.bind(this));

        }
        var $cartDelete = $('.js-ya-commerce-remove-cart');
        if ($cartDelete) {
            $cartDelete.click(function () {
                setPushes('remove', [{
                    "id": $(this).data('id'),
                    "name" : $(this).data('name'),
                    "category": $(this).data('category'),
                    "quantity": parseInt($(this).parents('.js-product-cart-item').find('.js-cart-quantity').val())
                }]);
            });
        }
    };
    setTriggers.bind(this);

    var init = function () {
        if (testContainer()) {
            this.actionField = null;
            findRoute();
            setPushes(this.route,this.products,this.actionField);
            setTriggers();
        }
    };
    init();


};



//////////////////
// WEBPACK FOOTER
// ./src/js/yandex_commerce.js
// module id = 4
// module chunks = 0 1 2